import { useApplets } from "./useApplets";

/** Return single applet */
export const useApplet = (id: string) => {
  const { data: { entities = {} } = {} } = useApplets();
  return entities[id];
};
